<div piTesting="allNavs">
    @if (showGlobalNav) {
        <global-nav
            [disableAll]="disableGlobalNav"
            (piAssistantClick)="piAssistantClick.emit()"
            (sellerToolsClick)="sellerToolsClick.emit()"
            (moduleClick)="moduleClick.emit()"
        ></global-nav>
    } @else {
        <legacy-spa-pi-nav
            [disableSearch]="disableSearch"
            (onUpgradeAccountClick)="onUpgradeAccountClick.emit()"
            [buttonTextKeyName]="buttonTextKeyName"
        ></legacy-spa-pi-nav>
    }
</div>
